import { Box } from '@mui/material';
import { IPatientReviews } from './PatientReviews';
import { imageBoxStyles, sideImageStyles } from './PatientReviews.styles';
import ImageAsset, { IImage } from '../ImageAsset/ImageAsset';
import { Maybe } from '@shared-components/types';
export const SideImage = ({
  imageAsset,
  hasButtonContent
}: {
  imageAsset?: IPatientReviews['imageLeftSide'];
  hasButtonContent?: Maybe<boolean>;
}) => {
  const widthSize = '100%';
  const objectFit = 'contain';
  return <Box data-testid="patient_reviews_sideimage-container" sx={imageBoxStyles} data-sentry-element="Box" data-sentry-component="SideImage" data-sentry-source-file="SideImage.tsx">
			<Box sx={sideImageStyles(hasButtonContent)} data-sentry-element="Box" data-sentry-source-file="SideImage.tsx">
				<ImageAsset desktopImage={imageAsset?.desktopImage as IImage} mobileImage={imageAsset?.mobileImage as IImage} isBackgroundImage={false} imageSx={{
        objectFit: objectFit,
        width: widthSize
      }} dataTestId={`patient-reviews_sideimage-left`} data-sentry-element="ImageAsset" data-sentry-source-file="SideImage.tsx" />
			</Box>
		</Box>;
};